import React from "react";
import { Container } from "reactstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { Col, Row, Space } from "antd";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowLeft01Icon,
  Building02Icon,
  Restaurant01Icon,
  UserGroup02Icon,
} from "@hugeicons/core-free-icons/index";
import { Link } from "react-router";

const HousingReports = () => {
  const { t } = useTranslation();

  const reports = [
    {
      key: "housing-contract-detail",
      icon: Building02Icon,
      title: t("HOUSING_CONTRACT_DETAIL_REPORT_TITLE"),
      to: "housing-contract-detail",
    },
    {
      key: "house-contract-campaigns",
      icon: UserGroup02Icon,
      title: t("HOUSE_CONTRACT_CAMPAIGNS_REPORT_TITLE"),
      to: "house-contract-campaigns",
    },
    {
      key: "food-contracts",
      icon: Restaurant01Icon,
      title: t("FOOD_CONTRACTS_REPORT_TITLE"),
      to: "food-contracts",
    },
    {
      key: "housing-comprehensive-detail",
      icon: Building02Icon,
      title: t("HOUSING_COMPREHENSIVE_DETAIL_TITLE"),
      to: "housing-comprehensive-detail",
    },
    {
      key: "housing-building-delegate-detail",
      icon: Building02Icon,
      title: t("HOUSING_BUILDGING_DELEGATE_REPORT_DETAIL_TITLE"),
      to: "housing-building-delegate-detail",
    },
  ];

  return (
    <div>
      <PageHeader title={t("HOUSING_REPORTS")} sticky={false} />
      <Container fluid>
        <Row justify="start" gutter={[16, 16]}>
          {reports.map((report) => (
            <Col md={12} span={24} key={report.key}>
              <ReportCard key={report.key} {...report} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default HousingReports;

const ReportCard = (props) => {
  const { icon, title, to } = props;

  return (
    <Link to={to} className="rounded-4 border border-1 p-4 w-100 justify-content-between d-flex align-items-center">
      <Space>
        <HugeiconsIcon className="d-flex" icon={icon} />
        <p className="m-0 fw-bold">{title}</p>
      </Space>

      <HugeiconsIcon icon={ArrowLeft01Icon} />
    </Link>
  );
};
